import { ExpandableText, Link, Text } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

type ReviewsSummaryProps = {
  summary?: string
}

export const ReviewsSummary = ({ summary }: ReviewsSummaryProps) => {
  const { t } = useTranslation()

  if (!summary) {
    return null
  }

  return (
    <div className="mb-4 sm:mb-6 border border-primary-default py-3 px-4">
      <Text variant="title-six" className="mb-2">
        {t('product.reviews.reviews_summary')}
      </Text>
      <ExpandableText>
        {({ isExpanded }) => (
          <>
            <ExpandableText.Content variant="body-sm" className="text-subtle">
              {summary}
            </ExpandableText.Content>
            <ExpandableText.Trigger>
              <Link
                as="button"
                type="button"
                variant="body-sm"
                className="underline text-left text-black"
              >
                {isExpanded ? t('action.read_less') : t('action.read_more')}
              </Link>
            </ExpandableText.Trigger>
          </>
        )}
      </ExpandableText>
    </div>
  )
}
